(() => {
  'use strict';
  if (window.coriumShadeGuideLoaded) return;
  window.coriumShadeGuideLoaded = true;
  let source = 'product_selector';
  let guideUsed = false;

  const root = variantId => [...document.querySelectorAll('[data-shade-guide]')]
    .find(el => el.getClientRects().length &&
      (!variantId || data(el).variants.some(v => String(v.id) === String(variantId))));
  const data = el => JSON.parse(el.querySelector('[data-shade-data]').textContent);
  // Quick view appends "-modal" to form IDs; resolve the actual local form.
  const form = el => el.closest('.product-section')?.querySelector('form[action*="/cart/add"]')
    || document.getElementById(el.dataset.formId);
  const selectedId = el => form(el)?.querySelector('[name="id"]')?.value;
  function track(name, variantId, guide) {
    try {
      const el = guide || root(variantId);
      if (!el || window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      const payload = {
        product_id: el.dataset.productId,
        variant_id: String(variantId || selectedId(el) || ''),
        guide_used: guideUsed,
        source
      };
      // No personal data, no persistent storage, no queued pre-consent events.
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        Promise.resolve(window.Shopify.analytics.publish(name, payload)).catch(() => {});
      }
    } catch (_) {
      // Analytics failure must never interrupt shade selection or checkout.
    }
  }
  function sync(el) {
    const selected = String(selectedId(el));
    el.querySelectorAll('[data-shade-card]').forEach(card => {
      const active = card.dataset.shadeCard === selected;
      card.classList.toggle('is-selected', active);
      card.querySelector('[data-shade-current]').hidden = !active;
    });
  }
  function error(el, message) {
    const node = el.querySelector('[data-shade-error]');
    node.textContent = message;
    node.hidden = false;
  }
  function close(el) {
    el.querySelector('dialog').close();
  }
  function bindDialog(el) {
    const dialog = el.querySelector('dialog');
    if (dialog.dataset.bound) return;
    dialog.dataset.bound = 'true';
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('csg-open');
      el.querySelector('[data-shade-open]')?.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right ||
          event.clientY < box.top || event.clientY > box.bottom) close(el);
    });
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-shade-open], [data-shade-close], [data-shade-choose], [data-shade-advice]');
    if (!button) return;
    const el = button.closest('[data-shade-guide]');
    if (!el) return;
    const dialog = el.querySelector('dialog');
    bindDialog(el);
    if (button.hasAttribute('data-shade-open')) {
      el.querySelector('[data-shade-error]').hidden = true;
      el.querySelectorAll('[data-shade-src]').forEach(img => {
        if (!img.hasAttribute('src')) img.src = img.dataset.shadeSrc;
      });
      sync(el);
      dialog.showModal();
      document.documentElement.classList.add('csg-open');
      guideUsed = true;
      track('corium_shade_guide_opened', null, el);
    } else if (button.hasAttribute('data-shade-close')) {
      close(el);
    } else if (button.hasAttribute('data-shade-choose')) {
      const variant = data(el).variants.find(v => String(v.id) === button.dataset.shadeChoose);
      if (!variant?.available) return;
      const section = el.closest('.product-section');
      // Re-query live inputs: Expanse may replace the form after initialization.
      const inputs = [...section.querySelectorAll('[data-variant-input]')]
        .filter(input => input.getAttribute('form') === form(el)?.id);
      const optionInputs = inputs.filter(input => input.dataset.index === (variant.optionIndex || 'option1'));
      const input = optionInputs.find(input => input.type === 'radio' && input.value === variant.name)
        || optionInputs.find(input => input.tagName === 'SELECT');
      if (!input) return error(el, 'No pudimos seleccionar el tono. Cierra la guía y usa el selector del producto.');
      source = 'shade_guide';
      if (input.type === 'radio') input.checked = true;
      else input.value = variant.name;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      if (String(selectedId(el)) !== String(variant.id)) {
        source = 'product_selector';
        return error(el, 'No se confirmó el tono. Cierra la guía y selecciónalo directamente en el producto.');
      }
      track('corium_shade_guide_selected', variant.id, el);
      source = 'product_selector';
      el.querySelector('[data-shade-selection]').textContent = `Tono elegido: ${variant.name}. Ya puedes agregarlo al carrito.`;
      close(el);
    } else {
      track('corium_shade_advice_clicked', null, el);
      button.disabled = true;
      button.textContent = 'Abriendo chat…';
      // Close the modal first: a native modal otherwise makes the chat inert.
      close(el);
      let opened = false;
      try {
        if (typeof window.CoriumOpenZipchat === 'function') {
          opened = await window.CoriumOpenZipchat();
        } else if (typeof window.Zipchat?.open === 'function') {
          opened = window.Zipchat.open({ open: true }) !== false;
        }
      } catch (_) { opened = false; }
      button.disabled = false;
      button.textContent = 'Consultar en el chat';
      if (!opened) {
        dialog.showModal();
        document.documentElement.classList.add('csg-open');
        error(el, 'El chat no está disponible en este momento. Inténtalo de nuevo en unos minutos.');
      }
    }
  });
  document.addEventListener('variant:change', event => {
    const variant = event.detail?.variant;
    const el = root(variant?.id);
    if (!el || !variant || !data(el).variants.some(v => String(v.id) === String(variant.id))) return;
    track('corium_shade_variant_selected', variant.id);
    el.querySelector('[data-shade-selection]').textContent = '';
  });
  document.addEventListener('ajaxProduct:added', event => {
    const item = event.detail?.product;
    const id = item?.variant_id || item?.id;
    const el = root(id);
    if (!el || !id || !data(el).variants.some(v => String(v.id) === String(id))) return;
    track('corium_shade_added_to_cart', id);
  });
})();